export default __webpack_public_path__ + "grid-icon.3eddb574.svg";